import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleUseProjectModel(
  state: State,
  { zone, project }: Boundaries["useProjectModel"]["success"],
): State {
  return state.map((res) =>
    res.zone.uuid === zone.uuid
      ? { ...res, projects: [project, ...res.projects] }
      : res,
  );
}

export { handleUseProjectModel };
